module.exports = {"TXTWCL_Login_to_bet":{"id":"TXTWCL_Login_to_bet","defaultMessage":"K sázení je nutné se přihlásit","track":"Login to Bet"}}